import "./Lulu.css";
import LuluLogo from "../../../../Assets/Lulu/lulu_logo.png"
import Fathima_logo from "../../../../Assets/Footer/fathima_Logo_fira.png"
import Kallyan_logo from "../../../../Assets/Footer/kallyan_logo_fira.jpeg"
import Elite_logo from "../../../../Assets/Footer/elite_logo_fira.png"
import Pothys_logo from "../../../../Assets/Footer/Pothys_logo_fira .png"
import bigbasket from "../../../../Assets/Lulu/bigbasket-logo.png"
import amazon from "../../../../Assets/Lulu/amazon-logo.png"
import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";
const logo = process.env.PUBLIC_URL + "/firanewlogo-cropped.svg";

function Lulu() {
    return <div className="lulu-container">
        <Container>
            <div className="lulu-content">
                <img src={logo} className="lulu-img" />
                <div className="available-at">
                    Our products now available at all
                </div>
                <div>
                    <img src={bigbasket} className="bigbasket-img" />
                    <img src={Fathima_logo} className="shop-img" />
                    <img src={Kallyan_logo} className="shop-img" />
                    <img src={LuluLogo} className="lulu-shop-img " />
                    <img src={Elite_logo} className="shop-img" />
                    <img src={Pothys_logo} className="shop-img" />
                    <img src={amazon} className="amazon-img" />


                </div>
                <div className="hyper-market">HYPERMARKETS</div>
                <div className="middle-east">Across the Middle East & India</div>
            </div>
        </Container>
    </div>;
}

export default Lulu;